import { CardContent, Grid, Typography} from "@mui/material"
import MyTable, { TableRow } from "../../../components/MyTable";

import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "../../my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { formatDateToTimestamp } from "../../../utils/date";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { InMyChargeEmployeePaymentSlipsRequestId } from "../../../store/slices/userRequests";


interface TablePaymentSlipsProps {
    requestId: InMyChargeEmployeePaymentSlipsRequestId,
    description: string;
    setDescription: (desc: string) => void;
    pageSize: number;
    setPageSize: (page: number) => void;
    page: number;
    setPage: (page: number) => void;
}

const TablePaymentSlips = ({
    requestId, 
    description,
    setDescription,
    pageSize,
    setPageSize,
    page,
    setPage,
}: TablePaymentSlipsProps) => {

    const {payments, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];

    const MyButton = (headRow: TableHeadRows, row: TableRow<string, any>) => {
        return (
            <DownloadButtonDocument
                minWidth={"2rem"}
                FirmaTop={row.FirmaTop}
                NroFs={row.NroFS}
                FirmadoFecha={row.FirmadoFecha} 
                IdDocument={row.NroBoletaNomina}
                requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                signDisabled={true}
                signButton={false}
            />
        )
    }
    
    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
            allowOrderAction: true,
        },{
            label: "Periodo",
            rowKeyName: "Periodo",
            buildOrderValue: (row: string) => {
                const value = row.split(" ").slice(1, 5).join("")
                return value
            },
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroDocumento",
            allowOrderAction: true,
        },{
            label: "Tipo de documento",
            rowKeyName: "TipoDocumento",
            allowOrderAction: true,
        },{
            label: "Fecha de envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fecha de firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: MyButton,
        }
    ,];

    return  (
        <>
        <MyTable
            key="tab-0"
            pageNumber={page}
            itemsPerPage={pageSize}
            totalItems={totalItems}
            totalPages={totalItems / pageSize}
            searchInputString={description}
            onChangePageNumber={setPage}
            onChangeItemsPerPage={setPageSize}
            onChangeSearchInputString={setDescription}
            hiddenSearchInput={false}
            tableHeadRows={tableHeadRows}
            // hiddenFilterOptions={hiddenFilterOptions}
            tableRows={payments}
            loading={false}
            cardComponent={{
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem">
                                        {row.Descripcion} 
                                    </Typography>
                                </Grid>
                                <Grid item >
                                    {row.VerBoleta !== 0 && row.NroFS && MyButton(null as any, row)}
                                </Grid>
                            </Grid>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Empresa: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Empresa}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoDocumento}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Período: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Periodo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Enviado el: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Firmado el: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>                                            
                            
                        </CardContent>
                    );
                },
                numberOfCards: 1,
                changeViewOptionHidden: true,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={true}
        />
        </>
    )
}

export default TablePaymentSlips